import React, { useEffect } from "react";
import "./New_Arrival.css";
import Common_Title from "../../common_components/common_title/Common_Title";
import Common_Product_Card from "../../common_components/common_product_card/Common_Product_Card";
import { useDispatch, useSelector } from "react-redux";
import { getOfferProduct } from "../../../features/home/homeSlice";
import { getAllNewArrival } from "../../../features/products/productsSlice";
import { variant_type } from "../../../utils/common";

const New_Arrival = () => {
  const dispatch = useDispatch();
  const newArrivalProducts = useSelector(
    (state) => state.product.allProductNewArrival,
  );
  useEffect(() => {
    dispatch(getAllNewArrival({}));
  }, [dispatch]);



  return (
    <section className="New_Arrival">
      <div className="container">
        <div className="main_div">
          <Common_Title title={"New Arrivals"} />

          <div className="all_cards_div">
            <div className="row">
              {newArrivalProducts?.length > 0 ? (
                newArrivalProducts?.map((product) => {
                  let metal;
                  let size;
                  let triple;
                  if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Single)
                  ) {
                    metal = product?.Product_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Double)
                  ) {
                    metal = product?.Product_Variants?.[0];
                    size = metal?.Double_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Triple)
                  ) {
                    metal = product?.Product_Variants?.[0];
                    size = metal?.Double_Variants?.[0];
                    triple = size?.Triple_Variants?.[0];
                  }

                  const activeVariant = triple || size || metal;

                  return (
                    <div className="col-xl-3 col-lg-4 col-sm-6 mb-5">
                      <Common_Product_Card
                        product={product}
                        id={product.id}
                        imgSrc={process.env.REACT_APP_IMG_URL + product.image}
                        vdoSrc={process.env.REACT_APP_IMG_URL + product.video}
                        productName={product.name}
                        sellingPrice={activeVariant?.price || 0}
                        mrp={activeVariant?.mrp || 0}
                        kgText={metal?.Metal?.name}
                        discount={
                          activeVariant?.mrp
                            ? (
                                ((parseFloat(activeVariant?.mrp || 0) -
                                  parseFloat(activeVariant?.price || 0)) /
                                  parseFloat(activeVariant?.mrp || 1)) *
                                100
                              ).toFixed(0)
                            : 0
                        }
                        feature={product?.Product_Fetures?.slice(0, 3)}
                        btnText={"Shop Now"}
                      />
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    fontWeight: "bold",
                    width: "100%",
                    color: "black",
                  }}
                >
                  Product Not Available
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default New_Arrival;
